module.exports = __webpack_public_path__ + "img/icon-expand.ac2d1c01.svg";